<template>
  <div>
    <Loading v-if="loading"></Loading>
    <Layout v-else>
      <div class="pt-4">
        <h3 style="font-weight: bold">Pinpad Transactions</h3>
      </div>
      <section class="pt-5">
        <Overview class="overview">
          <p slot="card-1-title">Total Pinpad Transaction Value</p>
          <h3 slot="card-1-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalPinpadSumValue"
              :options="options"
              @ready="getTotalPinpadSumValue"
            />
          </h3>
          <!-- <span slot="card-1-percent">+5%</span>
          <span slot="from" class="grey-color pl_4">from last month</span> -->

          <p slot="card-2-title">Total Pinpad Transaction Volume</p>
          <h3 slot="card-2-val">
            <ICountUp
              :delay="delay"
              :endVal="totalPinpadVolume"
              :options="options"
              @ready="getTotalPinpadVolume"
            />
          </h3>
          <!-- <span slot="card-2-percent">+5%</span> -->

          <!-- <p slot="card-3-title">Total Transfer Transaction Volume</p>
          <h3 slot="card-3-val">25,819</h3>
          <span slot="card-3-percent">+5%</span> -->

          <p slot="card-4-earnings">Total Earnings</p>
          <h3 slot="card-4-val">
            ₦<ICountUp
              :delay="delay"
              :endVal="totalPinpadEarnings"
              :options="options"
              @ready="getTotalPinpadEarnings"
            />
          </h3>
          <!-- <span slot="card-4-percent">+5%</span>
          <span slot="from" class="grey-color pl_4"></span> -->
        </Overview>
      </section>
      <section class="pt-5">
        <TransactionsList>
          <b-form-input
            slot="search-bar"
            class="d-none"
            type="search"
            placeholder="Search by name, agent id or terminal id"
            trim
          />
          <b-button slot="search-btn" class="d-none" variant="primary">
            Search
          </b-button>
          <b-form-select
            class="show-select"
            slot="select-entry"
            value="1"
            :options="pinpadEntries"
          ></b-form-select>
          <span slot="entries-no">of {{ pinpadEntries.length }} entries</span>
          <b-form-datepicker
            slot="start-date"
            id="pinpad-start-date"
            placeholder="Start date"
            locale="en"
            class="filter-date"
            :max="today"
            @input="enableEndDate"
            v-model="startDate"
          ></b-form-datepicker>
          <b-form-datepicker
            slot="end-date"
            id="pinpad-end-date"
            placeholder="End date"
            locale="en"
            class="filter-date"
            :disabled="disabled"
            :min="startDate"
            :max="today"
            @input="enableApply"
            v-model="endDate"
          ></b-form-datepicker>
          <b-form-input
            slot="start-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="end-range"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-input
            slot="status-input"
            class="trans-status"
            type="text"
            placeholder="Value"
            trim
          />
          <b-form-checkbox
            slot="save-default"
            class="save-filter"
            id="save-filter"
          >
            Save as default filter
          </b-form-checkbox>
          <b-button
            slot="clear-btn"
            class="btn-alt filter-btn"
            block
            variant="primary"
            @click="clearFilter"
          >
            Clear
          </b-button>
          <b-button
            slot="apply-btn"
            slot-scope="{ closeModal }"
            class="filter-btn"
            block
            variant="primary"
            :disabled="disabledApply"
            @click="
              closeModal();
              applyFilter();
            "
          >
            Apply
          </b-button>
          <b-table slot="table" hover :items="pinpadTableData"></b-table>
        </TransactionsList>
      </section>
    </Layout>
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import Overview from "@/components/Overview.vue";
import TransactionsList from "@/components/TransactionsList.vue";
import ICountUp from "vue-countup-v2";
import { mapState, mapActions } from "vuex";

export default {
  name: "PinpadTransactions",
  components: {
    Loading,
    Layout,
    Overview,
    ICountUp,
    TransactionsList,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      disabled: true,
      disabledApply: true,
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.pinpad.initialLoad,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,
      today: (state) => state.user.today,

      totalPinpadSumValue: (state) => state.pinpad.pinpadOverview.totalSumValue,
      totalPinpadVolume: (state) => state.pinpad.pinpadOverview.totalCount,
      totalPinpadEarnings: (state) => state.pinpad.pinpadOverview.earnings,
      pinpadTableData: (state) => {
        if (state.pinpad.pinpadTransactions.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.pinpad.pinpadTransactions.data;
        }
      },
      pinpadEntries: (state) => {
        if (state.pinpad.pinpadTransactions.data > 0) {
          return [...state.pinpad.pinpadTransactions.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
    }),
  },
  methods: {
    ...mapActions({
      pinpadTransactions: "pinpad/getPinpadTransactions",
      pinpadOverview: "pinpad/getPinpadOverview",
    }),
    getTotalPinpadSumValue(instance) {
      const that = this;
      instance.update(that.totalPinpadSumValue);
    },
    getTotalPinpadVolume(instance) {
      const that = this;
      instance.update(that.totalPinpadVolume);
    },
    getTotalPinpadEarnings(instance) {
      const that = this;
      instance.update(that.totalPinpadEarnings);
    },
    applyFilter() {
      this.pinpadTransactions({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearFilter() {
      (this.startDate = ""), (this.endDate = "");
    },
    enableEndDate() {
      this.disabled = false;
    },
    enableApply() {
      this.disabledApply = false;
    },
  },
  created() {
    this.pinpadTransactions({
      startDate: this.today,
      endDate: this.today,
    });
    this.pinpadOverview({ startDate: this.today, endDate: this.today });
  },
};
</script>

<style></style>
